// @flow

const DAYS_OF_WEEK = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export default DAYS_OF_WEEK;



// WEBPACK FOOTER //
// ./src/constants/days-of-week.js